import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-logout',
  imports: [],
  template: ''
})
export class LogoutComponent implements OnInit {

  constructor(private router: Router) {}

  ngOnInit() {
    localStorage.removeItem('user');
    this.router.navigate(['/login']);
  }

}
